export default __webpack_public_path__ + "static/HalvarBreit-Md-ef268c8eac377ce900053504d6dfbc07.woff";